<template>
    <div>
        <h2>{{ title }}</h2>
        <slot name="table"/>
    </div>
</template>

<script>
export default {
    props: ['title'],
};
</script>

<style lang="scss" scoped>
  .table-right {
      text-align: right;
  }
</style>
